export class Stopwatch {
  #start: number | null = null;
  #elapsed = 0;

  start() { this.#start = performance.now(); }
  stop()  { 
    if (this.#start) {
      this.#elapsed += performance.now() - this.#start; 
      this.#start = null; 
    }
  }
  reset() { 
    this.#start = null; 
    this.#elapsed = 0; 
  }

  getElapsedMs() {
    return this.#elapsed + (this.#start ? performance.now() - this.#start : 0);
  }
}